<template lang="">
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<div class="sf-input-group-wrapper">
					<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000002') }}</span>
					<div class="search-option-wrapper__normal">
						<el-select
							:value="plantCd"
							:placeholder="getMessage_('SWCC000002')"
							style="height: 40px"
							@change="
								value => {
									return changeValue({ name: 'plantCd', value: value });
								}
							"
						>
							<el-option v-for="(plant, index) in plants" :label="plant.text" :value="plant.value" :key="index"></el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="4.5">
				<sf-group-wrapper :label="getMessage_('SWCC000365')">
					<el-date-picker v-model="searchMonthData" type="month" placeholder="YYYY-MM" @change="change"> </el-date-picker>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
				{{ getButtonMsg_(scrId, 'CR') }}
			</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ScreenUsage/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		var date = new Date();
		var month = parseInt(date.getMonth() + 1);
		var day = date.getDate();
		if (month < 10) month = '0' + month;
		if (day < 10) day = '0' + day;
		var currentDate = date.getFullYear() + '-' + month;
		this.DEFAULT_ASSIGN({
			key: 'searchMonth',
			value: currentDate
		});
		return {
			searchMonthData: currentDate,
			plantData: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		change() {
			this.searchList();
		},
		async searchList(currentPage = 1, pageUnit = this.groups.pageUnit) {
			this.$sf_toggleLoading(true);
			let searchParams = {
				searchMonth: this.$moment(this.searchMonthData).format('YYYYMM')
			};

			await this.getScreenUsageHistory_({ searchParams, currentPage, pageUnit })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_(error.header.messageCd)
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async pageLoad() {
			await this.searchList();
		}
	},
	created() {
		this.getPlants_()
			.then(() => {
				this.pageLoad();
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message ? error.message : error
				});
				Promise.reject(error);
			});
		this.plantData = this.plant;
	}
};
</script>
<style>
.flexStyle {
	display: flex;
}
</style>
